import { whatIsContent } from "@/mocks/content";

export default function WhatIsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
              About
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4 md:mb-5">
              {whatIsContent.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {whatIsContent.description}
            </p>

            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b-2 border-background-300">
                    <th className="text-left py-3 pr-4 text-sm font-semibold text-foreground-800">Feature</th>
                    <th className="text-left py-3 pr-4 text-sm font-semibold text-foreground-500">Normal Searching</th>
                    <th className="text-left py-3 text-sm font-semibold text-primary-600">Hipobuy Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  {whatIsContent.comparisonRows.map((row, i) => (
                    <tr key={i} className="border-b border-background-200/60">
                      <td className="py-3 pr-4 text-sm font-medium text-foreground-800">{row.feature}</td>
                      <td className="py-3 pr-4 text-sm text-foreground-500">{row.normal}</td>
                      <td className="py-3 text-sm text-primary-700 font-medium">{row.hipobuy}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20an%20organized%20product%20research%20workspace%20with%20a%20large%20open%20notebook%20filled%20with%20handwritten%20comparison%20notes%2C%20swatches%20of%20fabric%20samples%20arranged%20in%20neat%20rows%2C%20a%20tablet%20showing%20colorful%20product%20grid%2C%20reading%20glasses%20resting%20on%20the%20notebook%2C%20warm%20morning%20sunlight%20casting%20gentle%20shadows%20across%20cream%20linen%20surface%2C%20scattered%20product%20tags%20with%20handwritten%20prices%2C%20ceramic%20coffee%20cup%20on%20the%20side%2C%20sophisticated%20editorial%20product%20catalog%20photography%20with%20rich%20terracotta%20and%20warm%20beige%20tones&width=800&height=600&seq=whatis-v2-2026-jul&orientation=landscape"
                alt="Hipobuy Spreadsheet product research and comparison tools"
                title="Hipobuy Spreadsheet - Product Research"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}